/**
 * taille_texte.tsx — INTEGRATION.BOITES lot G (DEC-TAILLE-TEXTE-1, Carl 21 oct. 2026) : trois tailles de texte pour les boîtes —
 * Petit, Normal, Grand — UN SEUL réglage pour toutes les boîtes, mémorisé par utilisateur, jamais par boîte.
 * Mécanique : <html data-taille-texte="petit|normal|grand"> → boites.css règle la variable --echelle du cadre Boite (0.875 / 1 / 1.2) ;
 * toutes les tailles de texte et les trois classes de chiffres (DEC-ECHELLE-CHIFFRES-1) suivent.
 * Mémoire : aucun endroit serveur n'existe pour les préférences d'affichage (menu utilisateur ControlTowerPanel.tsx : Mon Profil,
 * Réglages Généraux → AgentSettingsView V2, aucun réglage d'affichage) ; la préférence est gardée dans localStorage
 * (clé brain-team-taille-texte), sous try/catch : sans stockage, le réglage vaut pour la page ouverte seulement.
 */
import { useEffect, useState } from "react";

export type TailleTexte = "petit" | "normal" | "grand";
export const TAILLES: { code: TailleTexte; libelle: string; echelle: number }[] = [
  { code: "petit", libelle: "Petit", echelle: 0.875 },
  { code: "normal", libelle: "Normal", echelle: 1 },
  { code: "grand", libelle: "Grand", echelle: 1.2 },
];
export const CLE_TAILLE_TEXTE = "brain-team-taille-texte";

export function lireTailleTexte(): TailleTexte {
  try {
    const v = localStorage.getItem(CLE_TAILLE_TEXTE);
    if (v === "petit" || v === "normal" || v === "grand") return v;
  } catch { /* stockage indisponible : réglage de la page seulement */ }
  return "normal";
}

/** Applique le réglage à la page (attribut sur <html>) et le mémorise pour l'utilisateur. */
export function appliquerTailleTexte(t: TailleTexte): void {
  document.documentElement.setAttribute("data-taille-texte", t);
  try { localStorage.setItem(CLE_TAILLE_TEXTE, t); } catch { /* stockage indisponible */ }
}

/** Sélecteur « Aa » Petit / Normal / Grand de l'en-tête du workspace (pattern sous-tabs du design system : actif bg-gray-900 text-white). */
export function SelecteurTailleTexte({ compact = false }: { compact?: boolean }) {
  const [taille, setTaille] = useState<TailleTexte>(() => (typeof document === "undefined" ? "normal" : lireTailleTexte()));
  const [ouvert, setOuvert] = useState(false);
  useEffect(() => { appliquerTailleTexte(taille); }, [taille]);
  return (
    <div className="relative shrink-0" data-selecteur-taille-texte data-taille={taille}>
      <button type="button" onClick={() => setOuvert((o) => !o)} title="Taille du texte des boîtes" aria-label="Taille du texte des boîtes"
        className="p-1.5 rounded-lg hover:bg-gray-100 transition-colors text-[11px] font-bold text-gray-500 leading-none">Aa</button>
      {ouvert && (
        <div className="absolute right-0 mt-1 z-50 flex items-center gap-1 rounded-lg border border-gray-200 bg-white p-1 shadow-lg" role="group" aria-label="Taille du texte">
          {TAILLES.map((x) => (
            <button key={x.code} type="button" data-taille-choix={x.code} onClick={() => { setTaille(x.code); setOuvert(false); }}
              className={taille === x.code
                ? "px-3 py-1.5 text-xs font-medium rounded-md bg-gray-900 text-white shadow-sm"
                : "px-3 py-1.5 text-xs font-medium rounded-md text-gray-500 hover:bg-gray-100 hover:text-gray-700"}>
              {compact ? x.libelle[0] : x.libelle}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
